<div class="messages-container" *ngIf="currentMessage">
  <ifc-user-message-page
    *ngFor="let message of [currentMessage]; trackBy: trackByMessage"
    [message]="message"
    (acknowledged)="onMessageAcknowledged()"
  >
  </ifc-user-message-page>
</div>
